/**
 * created by xcc on 2022/5/23
 * 网站投递关系页面
 */
import React, {Component} from 'react';
import {Table, Button, Pagination, Modal, Row, Col, Radio} from "antd";
import {message} from "../sysManagement/utils/sysManagementUtils";
import {Scrollbars} from "react-custom-scrollbars";
import $ from "jquery";
import './websiteDeliverRelation.css';
import {deleteColumnSynById, getCurrentDeptColumnTree, getListData, saveColumnSyn} from "./deliverRelationAction";
import SelectTree from "./SelectTree";
import BaseComponent from "../../base/BaseComponent";

let height = window.innerHeight - 96;

class WebsiteDeliverRelation extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            size: 10,
            total: 0,
            listData: [],  //列表数据
            visible: false,
            title: "",
            deliveryWay: "0",
            autoExpandParent: true,
            treeData: [],  //筛选框数据
            expandedKeys1: [],
            expandedKeys2: [],
            checkedKeys1: {},
            checkedKeys2: {},
            selectedKey1: "",
            selectedKey2: "",
            newTreeData1: [], //选中后的树数据
            newTreeData2: [],
            rightData: [],
            leftData: [],
            hideOnSinglePage: true
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        //网站扩展字段列表
        this.getDeliverRelationList();
        //事件监听
        window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        window.location.reload();   //重新加载页面，类似f5刷新
    }

    componentWillUnmount() {
        // 一定要最后移除监听器，以防多个组件之间导致this的指向紊乱
        window.removeEventListener('resize', this.resize);
    }

    /**
     * 获取网站投递关系列表数据
     */
    getDeliverRelationList() {
        let params = {
            page: this.state.page,
            size: this.state.size,
        };
        getListData(params, (res) => {
            let listData = [];
            let total = 0;
            let hideOnSinglePage = true;
            if(res && res.data && res.data.length > 0){
                total = res.count;
                hideOnSinglePage = false;
                listData = res.data;
            }
            this.setState({
                listData,
                total,
                hideOnSinglePage
            }, () => {
                $('.ant-pagination-options-quick-jumper').find("input").val("");
            })
        })
    }

    /**
     * 获取媒体数据
     */
    getTreeData(callback) {
        window.loading.show();
        getCurrentDeptColumnTree({}, (data) => {
            window.loading.hide();
            let treeData = [];
            if (data && data.length) {
                treeData = data;
            }
            callback(treeData);
        })
    }

    /**
     * 渲染
     */
    render() {
        return (
            <div style={{margin: 15,}}>
                <div style={{
                    width: "100%",
                    height: height,
                }}>
                    {/*渲染头部*/}
                    {this.renderHeader()}
                    {/*渲染列表*/}
                    {this.renderTable()}
                    {/*渲染新增弹窗*/}
                    {this.renderAddModal()}
                </div>
            </div>
        )
    }

    renderHeader() {
        return (
            <div style={{background: 'white', padding: "24px 15px",borderRadius:"5px 5px 0 0"}}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                }}>
                    <Button style={{marginRight: "20px"}} onClick={() => {
                        this.addDeliverRelation()
                    }} type={"primary"}>
                        新增
                    </Button>
                </div>
            </div>
        )
    }

    addDeliverRelation() {
        //获取当前部门的所有网站栏目树
        this.getTreeData((treeData)=>{
            this.setState({
                visible: true,
                title: "投递关系添加",
                deliveryWay: "0",
                checkedKeys1: {},
                checkedKeys2: {},
                rightData: [],
                leftData: [],
                treeData
            },()=>{
                let defaultKey = undefined;
                if(treeData.length){
                    defaultKey = treeData[0].key;
                }
                this.getScreenTreeData(defaultKey);
            })
        });
    }

    deleteDeliverItem(record){
        Modal.confirm({
            title: '确认删除吗？',
            onOk: () => {
                deleteColumnSynById({columnSyncId: record.id}, (data) => {
                    if (data) {
                        message.success("删除成功");
                        if (this.state.listData.length === 1) {
                            this.paginationOnChange(this.state.page - 1, this.state.size)
                        } else {
                            this.paginationOnChange(this.state.page, this.state.size)
                        }
                    } else {
                        message.error("删除失败！");
                    }
                })
            }
        })
    }

    renderTable() {
        const columns = [
    //         {
    //             title: 'ID',
    //             key: 'ID',
    //             width: 60,
    //             render: (text, record, index) => {
    //                 return (
    //                     <div className={"id"} title={(index + 1) + (this.state.page - 1) * (this.state.size)} style={{
    //                         overflow: "hidden",
    //                         textOverflow: "ellipsis",
    //                         whiteSpace: "nowrap",
    //                     }}>{(index + 1) + (this.state.page - 1) * (this.state.size)}
    //                         <style>{`.id .tabList .ant-table-thead > tr > th:first-child, .ant-table-tbody > tr td:first-child{
    // padding: 16px 16px 16px 16px;overflow-wrap: break-word;}`}</style>
    //                     </div>
    //                 )
    //             }
    //         },
            {
                title: '来源站点',
                dataIndex: 'mediaName',
                key: 'mediaName',
                ellipsis: true,
            },
            {
                title: '来源资料源',
                key: 'contentName',
                dataIndex: 'contentName',
                ellipsis: true,
            },
            {
                title: '目的站点',
                key: 'bindMediaName',
                dataIndex: 'bindMediaName',
                ellipsis: true,
            },
            {
                title: '目的资料源',
                key: 'bindContentName',
                dataIndex: 'bindContentName',
                ellipsis: true,
            },
            {
                title: '投递方式',
                key: 'deliveryWay',
                ellipsis: true,
                render: (record) => {
                    return (
                        <div>{record.deliveryWay ? "链接形式" : "正文形式"}</div>
                    )
                }
            },
            {
                title: '操作',
                key: 'operate',
                ellipsis: true,
                render: (record) => {
                    return (
                        <div style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), cursor: "pointer"}} onClick={()=>{
                            this.deleteDeliverItem(record)
                        }}>删除</div>
                    )
                }
            }
        ];
        return (
            <div id="table" style={{background: 'white',borderRadius:"0 0 5px 5px"}}>
                <div style={{boxSizing:"border-box",padding:"0px 15px 10px"}}>
                    <Scrollbars autoHide autoHeight autoHeightMax={height - 159}>
                        <Table columns={columns} dataSource={this.state.listData} pagination={false}/>
                    </Scrollbars>
                </div>
                {this.state.listData && this.state.listData.length>0 ? <div style={{
                    padding: "16px 10px",
                    display: "flex",
                    justifyContent: "flex-end",
                    backgroundColor: "#ffffff",
                    borderTop: "1px solid #e6e6e6",
                    borderRadius: "0 0 5px 5px"
                }}>
                    <Pagination
                        onChange={(page, pageSize) => {
                            this.paginationOnChange(page, pageSize)
                        }}//页码改变回调
                        onShowSizeChange={(page, pageSize) => {
                            this.state.hideOnSinglePage = false;
                            this.paginationOnChange(page, pageSize)
                        }}//每页条数改变回调
                        defaultCurrent={1}
                        defaultPageSize={10}
                        total={this.state.total}
                        showTotal={total => `共${total}条`}
                        current={this.state.page}
                        pageSize={this.state.size}
                        showSizeChanger
                        showQuickJumper
                        hideOnSinglePage={this.state.hideOnSinglePage}
                    />
                </div> : ""}

                <style>{`
                    #table .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                    #table .ant-table-placeholder{border-bottom: 0;}
                `}</style>
            </div>
        )
    }

    renderAddModal() {
        return (
            <div>
                <Modal
                    title={this.state.title}
                    visible={this.state.visible}
                    width={850}
                    height={572}
                    zIndex={500}
                    onCancel={() => {
                        this.onCancel();
                    }}
                    onOk={() => {
                        this.onOk();
                    }}
                    maskClosable={false}
                    centered
                >
                    <div>
                        <div style={{marginBottom: "20px"}}>
                            <Row>
                                <Col span={3}>
                                    <div className={"deliverRelationTitle"}>投递方式：</div>
                                </Col>
                                <Col span={21}>
                                    <Radio.Group onChange={e => {
                                        this.setState({
                                            deliveryWay: e.target.value
                                        })
                                    }} value={this.state.deliveryWay}>
                                        <Radio value={"0"}>正文形式</Radio>
                                        <Radio value={"1"}>链接形式</Radio>
                                    </Radio.Group>
                                </Col>
                            </Row>
                        </div>
                        <div style={{marginBottom: "20px"}}>
                            <Row>
                                <Col span={3}>
                                    <div style={{lineHeight: "32px"}} className={"deliverRelationTitle"}>媒体选择：</div>
                                </Col>
                                <Col span={9}>
                                    <SelectTree
                                        getScreenTreeData={(selectedKey) => {
                                            this.getScreenTreeData(selectedKey, "expandLeft")
                                        }}
                                        onCheck={(checkedKeys, e) => {
                                            this.onCheck(checkedKeys, e)
                                        }}
                                        onExpand={(expandedKeys) => {
                                            this.onExpand(expandedKeys, "expandLeft")
                                        }}
                                        treeData={this.state.treeData}
                                        newTreeData={this.state.newTreeData1}
                                        selectedKey={this.state.selectedKey1}
                                        expandedKeys={this.state.expandedKeys1}
                                        checkedKeys={this.state.checkedKeys1}
                                        autoExpandParent={this.state.autoExpandParent}
                                    />
                                </Col>
                                <Col span={3}>
                                    <div style={{lineHeight: "32px"}} className={"deliverRelationTitle"}>目的站点选择：</div>
                                </Col>
                                <Col span={9}>
                                    <SelectTree
                                        getScreenTreeData={(selectedKey) => {
                                            this.state.rightData = [];
                                            this.state.checkedKeys2 = [];
                                            this.getScreenTreeData(selectedKey, "expandRight")
                                        }}
                                        onCheck={(checkedKeys, e) => {
                                            this.onCheck(checkedKeys, e, true);
                                        }}
                                        onExpand={(expandedKeys) => {
                                            this.onExpand(expandedKeys, "expandRight")
                                        }}
                                        treeData={this.state.treeData}
                                        newTreeData={this.state.newTreeData2}
                                        selectedKey={this.state.selectedKey2}
                                        expandedKeys={this.state.expandedKeys2}
                                        checkedKeys={this.state.checkedKeys2}
                                        autoExpandParent={this.state.autoExpandParent}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }

    onCheck(checkedKeys, e, multiple) {
        if (multiple) {
            //右侧选中数据
            let rightData = [];
            e.checkedNodes.forEach(item => {
                let newItem = item.props.dataRef;
                rightData.push({
                    "contentId": newItem.contentId,
                    "contentName": newItem.contentName,
                    "mediaId": newItem.mediaId,
                    "mediaName": newItem.mediaName,
                    "treeId": newItem.treeId,
                    "treeName": newItem.treeName
                })
            })
            this.setState({
                checkedKeys2: checkedKeys,
                rightData
            });
        } else {
            //左侧选中数据
            let leftData = [];
            e.checkedNodes.forEach(item => {
                let newItem = item.props.dataRef;
                leftData.push({
                    "contentId": newItem.contentId,
                    "contentName": newItem.contentName,
                    "mediaId": newItem.mediaId,
                    "mediaName": newItem.mediaName,
                    "treeId": newItem.treeId,
                    "treeName": newItem.treeName
                })
            })
            while (checkedKeys.checked.length > 1) {
                checkedKeys.checked.shift();
            }
            this.setState({
                checkedKeys1: checkedKeys,
                leftData
            });
        }
    }

    onExpand(expandedKeys, operate) {
        if (operate === "expandLeft") {
            this.state.expandedKeys1 = expandedKeys;
        } else {
            this.state.expandedKeys2 = expandedKeys;
        }
        this.setState({
            autoExpandParent: false
        });
    }

    getScreenTreeData(selectedKey, operate) {
        let newTreeData = [];
        let expandedKeys = [];
        this.state.treeData.length && this.state.treeData.forEach(item => {
            if (selectedKey === item.key) {
                newTreeData.push(item);
                expandedKeys.push(item.key);
            }
        })
        this.filterData(newTreeData);
        if (operate) {
            if (operate === "expandLeft") {
                this.state.expandedKeys1 = expandedKeys;
                this.state.selectedKey1 = selectedKey;
                this.state.newTreeData1 = newTreeData;
            } else {
                this.state.expandedKeys2 = expandedKeys;
                this.state.selectedKey2 = selectedKey;
                this.state.newTreeData2 = newTreeData;
            }
        } else {
            this.state.expandedKeys1 = expandedKeys;
            this.state.selectedKey1 = selectedKey;
            this.state.expandedKeys2 = expandedKeys;
            this.state.selectedKey2 = selectedKey;
            this.state.newTreeData1 = newTreeData;
            this.state.newTreeData2 = newTreeData;
        }
        this.setState({})
    }

    filterData(data) {
        data.length && data.forEach((item, index) => {
            item = {
                id: item.key,
                key: item.key,
                title: item.title,
                children: item.subtree,
                ...item,
            }
            data[index] = item;
            if (item.children && item.children.length) {
                this.filterData(item.children);
            } else {
                data[index].children = [];
            }
        })
    }

    onCancel() {
        this.setState({
            visible: false
        })
    }

    onOk() {
        console.log(this.state.leftData);
        console.log(this.state.rightData);
        let flag = false;
        if (!this.state.leftData.length) {
            message.error("请选择媒体栏目！");
            return;
        }
        if (!this.state.rightData.length) {
            message.error("请选择目的站点栏目！");
            return;
        }
        this.state.checkedKeys1 && this.state.checkedKeys1.checked.length && this.state.checkedKeys1.checked.forEach(item => {
            flag = this.state.checkedKeys2 && this.state.checkedKeys2.checked.length && this.state.checkedKeys2.checked.indexOf(item) > -1;
        })
        if (flag) {
            message.error("不能选择同一栏目！");
            return;
        }
        let params = {
            column: this.state.leftData[0],
            deliveryColumns: this.state.rightData,
            deliveryWay: this.state.deliveryWay
        }
        saveColumnSyn(params, (data) => {
            if(data){
                message.success("新增成功");
                this.state.visible = false;
                this.getDeliverRelationList();
            }
        })

    }

    paginationOnChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.getDeliverRelationList();
    }
}

export default WebsiteDeliverRelation;